import { useState, useEffect } from 'react';

const useLocalStorage = (key, initial) => {
  const [val, setVal] = useState(() => {
    try { return JSON.parse(localStorage.getItem(key)) || initial; } catch { return initial; }
  });
  useEffect(() => localStorage.setItem(key, JSON.stringify(val)), [val, key]);
  return [val, setVal];
};

export default useLocalStorage;
